var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { css, styled, ThemeProvider } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const overrideHideStyles = css `width:auto;height:auto;clip:auto;overflow:visible;`;
const StyledSkipWrapper = styled.div.withConfig({ displayName: "StyledSkipWrapper", componentId: "sc-118cjlx" }) `position:absolute;width:1px;height:1px;clip:rect(0 0 0 0);overflow:hidden;z-index:1;background:${(props) => props.theme.colors.focus.main};padding:${(props) => props.theme.size.static250};border:${({ theme }) => theme.size.line.default} solid ${(props) => props.theme.colors.border.hover};a{color:${(props) => props.theme.colors.content.inverted};}:focus-within,:hover{${overrideHideStyles}}${(props) => props.visible && overrideHideStyles}`;
export function SkipLink(props) {
    const { children, visible } = props, rest = __rest(props, ["children", "visible"]);
    const commonProps = getCommonProps(props);
    return (React.createElement(ThemeProvider, { theme: "main" },
        React.createElement(StyledSkipWrapper, Object.assign({ visible: visible }, commonProps, rest), children)));
}
